import React, { Fragment, useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"

import { Button, ConfirmationModal } from "components"
import { receivedStockTransferRequest } from "services"
import classes from "./StrrrmFooter.module.scss"

const StrrrmFooter = (props) => {
  const {
    receivedNote,
    receivedItems,
    stockTransferRequest,
    setStockTransferRequests,
    setShowStockTransferReceiveModal
  } = props

  const [sending, setSending] = useState(false)
  const [openReceiveConfirmationModal, setOpenReceiveConfirmationModal] = useState(false)

  const unmount = useRef(false)
  const handleApprove = async () => {
    setSending(true)

    const items =
      receivedItems.map(receivedItem => ({
        foodId: receivedItem.foodId,
        optionId: receivedItem.optionId,
        receivedQuantity: Number(receivedItem.receivedQuantity)
      }))

    try {
      const response =
        await receivedStockTransferRequest(
          stockTransferRequest._id,
          {
            receivedNote,
            receivedItems: items
          }
        )

      if (unmount.current) return

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === response._id
            ? { ...str, ...response }
            : str
        )
      )

      setShowStockTransferReceiveModal(false)

      setOpenReceiveConfirmationModal(false)
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error("عملیات انجام نشد")
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <div className={classes["footer"]}>
        <Button
          color="success"
          onClick={() => setOpenReceiveConfirmationModal(true)}
        >
          ارسال گزارش
        </Button>
      </div>
      <ConfirmationModal
        loading={sending}
        title="آیا می خواهید این گزارش را ارسال کنید ؟"
        show={openReceiveConfirmationModal}
        onConfirm={handleApprove}
        onHide={() => setOpenReceiveConfirmationModal(false)}
      />
    </Fragment>
  )
}

export default StrrrmFooter